import { forwardRef, type Ref, type SVGProps } from "react";

function SvgRemove(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m10 6-4 4m4 0L6 6m8.333 2A6.333 6.333 0 1 1 1.667 8a6.333 6.333 0 0 1 12.666 0"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRemove);
export default ForwardRef;
